exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form_title[data-v-5118a3ce] {\n  color: #235AA3;\n  font-size: 24px;\n  line-height: 35px;\n  font-weight: bold;\n  text-align: center;\n}", ""]);

// exports
